import { useEffect, useState } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Download, Smartphone, Wifi, Zap } from "lucide-react"
import { usePwaInstall } from "@/hooks/usePwaInstall"

export function PwaInstallPopup() {
  const { showWeeklyPopup, promptInstall, dismissPopup } = usePwaInstall()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (showWeeklyPopup) {
      const timer = setTimeout(() => setOpen(true), 3000)
      return () => clearTimeout(timer)
    }
  }, [showWeeklyPopup])

  const handleInstall = async () => {
    await promptInstall()
    setOpen(false)
  }

  const handleDismiss = () => {
    dismissPopup()
    setOpen(false)
  }

  if (!showWeeklyPopup) return null

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleDismiss() }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#0d2846] to-[#e2af58] flex items-center justify-center">
              <Download className="h-6 w-6 text-white" />
            </div>
            <div>
              <DialogTitle className="text-lg">Install Pabandi Portal</DialogTitle>
              <DialogDescription>Get the full app experience</DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="flex items-center gap-3 text-sm text-muted-foreground">
            <Zap className="h-4 w-4 text-[#e2af58]" />
            <span>Faster loading & instant access</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-muted-foreground">
            <Smartphone className="h-4 w-4 text-[#e2af58]" />
            <span>Works like a native app on your device</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-muted-foreground">
            <Wifi className="h-4 w-4 text-[#e2af58]" />
            <span>Push notifications for important alerts</span>
          </div>
        </div>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1" onClick={handleDismiss}>
            Maybe Later
          </Button>
          <Button
            className="flex-1 bg-gradient-to-r from-[#0d2846] to-[#0d2846]/90 hover:from-[#0d2846]/90 hover:to-[#0d2846]/80 text-white"
            onClick={handleInstall}
          >
            <Download className="h-4 w-4 mr-2" />
            Install Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
